import { Box } from '@mui/material';

const NoShadowBox = ({ children }) => (
  <Box
    sx={{
      '& .MuiCard-root': {
        boxShadow: 'none',
      },
    }}
  >
    {children}
  </Box>
);

export default NoShadowBox;
